export default "__VITE_ASSET__7b687f1d__"